(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ac-cart-upsell"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const quantityButtons = document.querySelectorAll('.cart-upsell__quantity-btn');
    
    quantityButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        const action = this.dataset.action;
        const quantityContainer = this.closest('.cart-upsell__quantity');
        const input = quantityContainer.querySelector('.cart-upsell__quantity-input');
        let currentValue = parseInt(input.value) || 1;
        
        if (action === 'increase') {
          input.value = currentValue + 1;
        } else if (action === 'decrease' && currentValue > 1) {
          input.value = currentValue - 1;
        }
      });
    });

    // Handle form submission to reload page after adding to cart
    const upsellForms = document.querySelectorAll('.cart-upsell__form');
    
    upsellForms.forEach(form => {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        
        const formData = new FormData(form);
        
        fetch(form.action, {
          method: 'POST',
          body: formData
        })
        .then(response => response.json())
        .then(data => {
          // Reload the page to update the cart
          window.location.reload();
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
          // Reload anyway to show updated cart state
          window.location.reload();
        });
      });
    });

    // Watch for cart changes using MutationObserver
    const cartElement = document.querySelector('form[action*="/cart"]') || document.querySelector('.cart') || document.querySelector('[data-cart]');
    
    if (cartElement) {
      const observer = new MutationObserver(function(mutations) {
        let cartChanged = false;
        
        mutations.forEach(function(mutation) {
          // Check if cart items were added or removed
          if (mutation.type === 'childList' && mutation.removedNodes.length > 0) {
            cartChanged = true;
          }
          // Check if attributes changed (like quantity updates)
          if (mutation.type === 'attributes' || mutation.type === 'characterData') {
            cartChanged = true;
          }
        });
        
        if (cartChanged) {
          // Debounce the reload to avoid multiple reloads
          clearTimeout(window.cartReloadTimeout);
          window.cartReloadTimeout = setTimeout(function() {
            window.location.reload();
          }, 1000);
        }
      });
      
      observer.observe(cartElement, {
        childList: true,
        subtree: true,
        attributes: true,
        characterData: true
      });
    }

    // Also listen for cart form submissions (quantity changes, removals)
    // But exclude checkout button
    const cartForms = document.querySelectorAll('form[action*="/cart"]');
    cartForms.forEach(function(form) {
      form.addEventListener('submit', function(e) {
        // Check if this is a checkout action
        const submitButton = e.submitter;
        if (submitButton) {
          const buttonName = submitButton.getAttribute('name');
          const buttonAction = submitButton.getAttribute('formaction');
          const buttonHref = submitButton.getAttribute('href');
          
          // Don't reload if this is a checkout button
          if (buttonName === 'checkout' || 
              buttonAction && buttonAction.includes('checkout') ||
              buttonHref && buttonHref.includes('checkout') ||
              submitButton.classList.contains('checkout') ||
              submitButton.id && submitButton.id.includes('checkout')) {
            return;
          }
        }
        
        // Only reload for cart updates, not checkout
        setTimeout(function() {
          window.location.reload();
        }, 500);
      });
    });

    // Listen for specific Shopify cart events
    document.addEventListener('cart:updated', function() {
      window.location.reload();
    });
    
    document.addEventListener('cart:refresh', function() {
      window.location.reload();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
